module.exports = __webpack_public_path__ + "img/car_7.050a5bdd.jpeg";